import { Loader } from '@mantine/core';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import SaveTimeIcon from '@assets/logos/app_loading.gif';
import { useStore } from '@stores';

export const AppLoading = () => {
  const { t } = useTranslation('appLoading');
  const {
    initializeStore: { showGenericAnimation },
  } = useStore();

  return (
    <Stack
      direction="column"
      justifyContent="center"
      textAlign="center"
      alignItems="center"
      spacing={3}
      width="100%"
      height="100%"
    >
      {showGenericAnimation && <Loader color="blue" type="bars" size="lg" />}
      {!showGenericAnimation && (
        <img src={SaveTimeIcon} alt="Save Time Logo" width="111px" />
      )}
      <Stack spacing={2} maxWidth={380}>
        <Typography variant="h1" fontWeight={600}>
          {t('header')}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            whiteSpace: 'pre-line',
          }}
        >
          {t('subHeader')}
        </Typography>
      </Stack>
    </Stack>
  );
};
